import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { useFrameUpload } from "../../hooks/useFrameUpload";
import { useApiError } from "../../hooks/useApiError";
import { submitCheck } from "./submitCheck";
import { checkWithLiveness } from "../../api/liveness";
import { fireConfetti } from "../../utils/fireConfetti";

// Sends the attempt either through AWS Face Liveness (preferred) or the legacy frame path.
export const useCheckSubmit = ({ branchId, dutyId, action, locate, liveness, onDone, ui, qrCode, greeting }) => {
  const { t } = useTranslation();
  const describe = useApiError();
  const uploadFrames = useFrameUpload();

  const fail = (text) => {
    ui.setPhase("error");
    ui.setMessage(text);
    toast.error(text);
    liveness.newSession();
  };

  const complete = async (request) => {
    ui.setPhase("verifying");
    ui.setMessage(t("check.verifying"));
    try {
      const res = await request();
      ui.setSimilarity(res.verification.similarity);
      ui.setPhase("success");
      ui.setMessage(t("check.success"));
      toast.success(t("check.success"));
      if (action === "in") {
        fireConfetti();
        greeting?.play();
      }
      await onDone();
      setTimeout(() => ui.setOpen(false), 1400);
    } catch (error) {
      fail(describe(error));
    }
  };

  const submit = (grabFrames) =>
    complete(async () => {
      const coords = await locate();
      const frames = await grabFrames(3);
      return submitCheck({
        body: { action, branch_id: branchId, duty_id: dutyId || null, qr_code: qrCode || null, ...coords, challenge: "blink" },
        frames,
        uploadFrames,
      });
    });

  const submitLiveness = (sessionId) =>
    complete(async () => {
      const coords = await locate();
      return checkWithLiveness({
        session_id: sessionId,
        action,
        branch_id: branchId,
        duty_id: dutyId || null,
        qr_code: qrCode || null,
        ...coords,
      });
    });

  return { submit, submitLiveness, fail };
};
